module.exports = __webpack_public_path__ + "static/media/RLC_8299a.715206d4.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/kukenan/RLC_8299a.JPG
// module id = 113
// module chunks = 0